import * as CardActivity from '@/src/experiences/card-activity'
import { mesaColorNames, typography, spacing } from '@/src/common/theme'
import { StyleSheet, Text, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing['4'],
    gap: spacing['4'],
  },
  text: {
    ...typography['label/sm-regular'],
  },
})

export const RewardsComponentsActivityFeedEmptyState = () => (
  <View style={styles.container}>
    <CardActivity.Components.Highnote.NoTransactionsIcon
      pathProps={{
        stroke: mesaColorNames['Mesa - Brand/Blackish #222222'],
      }}
    />
    <Text style={styles.text}>No points activity</Text>
  </View>
)
